import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { TokenUserInfo } from '../db/tokenUserInfo.js';
import { getPredictedTokenUserInfoResolver } from '../server/resolver/tokenUserInfo.js';

export const getPredictedTokenUserInfo = registerQuery({
  operationName: 'getPredictedTokenUserInfo',
  resolve: getPredictedTokenUserInfoResolver,
  type: () => TokenUserInfo,
  params: [
    { name: 'examShortToken', type: () => String },
    { name: 'room', type: () => Int },
  ],
});
